import styled from "@emotion/styled";

import ExtendedErrorLogImage from "./ExtendedErrorLog.png";

export const ExtendedErrorLogImageContainer = styled.div({
    marginTop: 20,
    marginBottom: 40,
    width: 444,
    height: 138,
    backgroundSize: "cover",
    backgroundImage: `url(${ExtendedErrorLogImage})`,
});
